import React from 'react';
import TopicItem from './TopicItem';
import {
  SectionWrapper,
  SectionHeader,
  SectionTitle,
  ViewPhotosLink,
  ItemsContainer,
  Column,
} from './TopicSummary.styles';

const TopicSection = ({
  title,
  items,
  photos,
  twoColumns,
  viewPhotosLabel = 'Ver fotos',
  firstColumnItems: firstCol,
  secondColumnItems: secondCol,
  onViewPhotos,
  hasPhotosInGallery,
}) => {
  const renderItems = itemList =>
    itemList.map((item, index) => (
      <TopicItem key={index} text={item.text} needsAttention={item.needsAttention} />
    ));

  let firstColumnItems = firstCol;
  let secondColumnItems = secondCol;

  if (!firstColumnItems && !secondColumnItems && items) {
    const midIndex = items.length > 0 ? Math.ceil(items.length / 2) : 0;
    firstColumnItems = twoColumns ? items.slice(0, midIndex) : items;
    secondColumnItems = twoColumns ? items.slice(midIndex) : [];
  }

  const handleViewPhotos = () => {
    if (onViewPhotos) {
      onViewPhotos(title);
    }
  };

  // Verifica se há fotos disponíveis na galeria para esta seção
  const hasPhotos = hasPhotosInGallery && hasPhotosInGallery(title);

  return (
    <SectionWrapper>
      <SectionHeader>
        <SectionTitle>{title}</SectionTitle>
        {hasPhotos && <ViewPhotosLink onClick={handleViewPhotos}>{viewPhotosLabel}</ViewPhotosLink>}
      </SectionHeader>
      {twoColumns ? (
        <ItemsContainer>
          <Column>{firstColumnItems && renderItems(firstColumnItems)}</Column>
          <Column>{secondColumnItems && renderItems(secondColumnItems)}</Column>
        </ItemsContainer>
      ) : (
        items && renderItems(items)
      )}
    </SectionWrapper>
  );
};

export default TopicSection;
